import { UserRole } from '@/constants';

export const USER_STATUS = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
} as const;

export type UserStatus = typeof USER_STATUS[keyof typeof USER_STATUS];

export interface BackendUser {
  id: number;
  email: string;
  firstName: string | null;
  lastName: string | null;
  role: UserRole;
  createdAt: string;
  updatedAt: string;
  balance: number;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  ticket: string;
  password: string;
}

export interface ResetPasswordRequest {
  email: string;
}

export interface ResetPasswordConfirmation {
  code: string;
  password: string;
}

/**
 * Shape returned by the admin user endpoints (GET/POST/PATCH /admin/users).
 * Distinct from BackendUser (/users/me): the admin summary carries `status` and
 * a computed `balance`, but not the createdAt/updatedAt timestamps.
 */
export interface AdminUser {
  id: number;
  email: string;
  firstName: string | null;
  lastName: string | null;
  role: UserRole;
  status: UserStatus;
  balance: number;
}

/**
 * One package a user has ever held, active or revoked (GET
 * /admin/users/:userId/packages). Each grant is its own InterviewTemplate;
 * `activeTemplateCount` 0 with `lastRevokedAt` set means all were revoked.
 */
export interface AdminUserPackage {
  packageId: string;
  name: string;
  activeTemplateCount: number;
  openSittingCount: number;
  /** Each active template's included credits, frozen at grant time. */
  templateCredits: number[];
  /** Sum of templateCredits, capped at the user's current balance. */
  creditsToRevoke: number;
  lastRevokedAt: string | null;
}
